export default _config => ({
  // local environment overrides (reference the passed config when adding any)
})
